import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import vestel_logo from "../../../assets/images/vestel_logo.png";
import akilli_yasam_logo from "../../../assets/images/Vestel_Akilli_Yasam_ikon_final.png";
import akilli_saglik_logo from "../../../assets/images/Vestel_Akilli_Saglik_ikon_final.png";
import regal_logo from "../../../assets/images/regal_logo.png";
import vsoutlet_logo from "../../../assets/images/vsoutlet_logo.png";
import { useTranslation } from "react-i18next";

const BrandLogo = ({ country }) => {
  const { t } = useTranslation();

  const vsglobalStoreUrl = process.env.REACT_APP_GLOBAL_STORE_URL;
  const vestelStoreUrl = process.env.REACT_APP_STORE_URL;
  const regalStoreUrl = process.env.REACT_APP_REGAL_STORE_URL;
  const vsoutletStoreUrl = process.env.REACT_APP_VSOUTLET_STORE_URL;
  const supportUrl = process.env.REACT_APP_SUPPORT_URL;

  let userDevice = navigator.userAgent || window.opera;
  const isIOS = /iPad|iPhone|iPod/.test(userDevice) && !window.MSStream;
  const prefix = country === "DE" ? "GLOBAL" : "VESTEL";
  const platform = isIOS ? "IOS" : "ANDROID";

  const smartLife = process.env[`REACT_APP_${prefix}_SMART_${platform}_URL`];
  const smartHealth = process.env[`REACT_APP_${prefix}_HEALTH_${platform}_URL`];

  const logos = [
    {
      id: 1,
      name: t("layout.vestel-brand"),
      image: vestel_logo,
      link: country === "DE" ? vsglobalStoreUrl : vestelStoreUrl,
      style: { width: "64px", height: "14px" },
    },
    {
      id: 2,
      name: t("layout.vestel-akilli-yasam"),
      image: akilli_yasam_logo,
      link: smartLife,
      style: { width: "32px", height: "32px" },
    },
    ...(country !== "DE"
      ? [
          {
            id: 3,
            name: t("layout.vestel-akilli-saglik"),
            image: akilli_saglik_logo,
            link: smartHealth,
            style: { width: "32px", height: "32px" },
          },
          {
            id: 4,
            name: t("layout.vsoutlet-brand"),
            image: vsoutlet_logo,
            link: vsoutletStoreUrl,
            style: { width: "56px", height: "18px" },
          },
          {
            id: 5,
            name: t("layout.regal-brand"),
            image: regal_logo,
            link: regalStoreUrl,
            style: { width: "56px", height: "12px" },
          },
        ]
      : []),
    {
      id: 6,
      name: t("layout.vestel-support-center"),
      image: vestel_logo,
      link: supportUrl,
      style: { width: "64px", height: "14px" },
    },
  ];
  return (
    <div className="!flex flex-row justify-center items-center md:w-11/12 mx-auto bg-white rounded brand-logo-container pb-2">
      <Swiper
        slidesPerView={"auto"}
        spaceBetween={10}
        loop={false}
        scrollbar={{
          hide: true,
        }}
        modules={[Scrollbar]}
        breakpoints={{
          300: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          390: {
            slidesPerView: 3.5,
            spaceBetween: 10,
          },
          480: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 4.5,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 15,
          },
        }}
        className="brand-logo-container w-[100%]"
      >
        {logos.map((logo) => (
          <SwiperSlide className="brand-logo-swiper" key={logo.id}>
            <a className="brand-logo" href={logo.link}>
              <img src={logo.image} alt={logo.name} style={logo.style} />
              <div className="brand-title text-zinc-700 font-medium text-center font-league-medium">
                {logo.name}
              </div>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BrandLogo;
